import {CHANGE_ODDS_TYPE, CHANGE_SYSTEM_LANGUAGE, OPEN_CLOSE_SETTINGS} from '../constants/actionTypes';
import {isLocalStorageAvailable} from '../helpers/systemHelpers';
import {setItem} from "../helpers/localStorageHelpers";
import {ODDS_TYPE, SYS_LANGUAGE} from "../constants/localStorage";

export function openCloseSettings() {
    return {type: OPEN_CLOSE_SETTINGS};
}

export function changeOddsType(playerUID, oddsType) {
    if (isLocalStorageAvailable) {
        setItem(playerUID, ODDS_TYPE, oddsType);
    }

    return {type: CHANGE_ODDS_TYPE, oddsType};
}

export function changeSystemLanguage(playerUID, language) {
    if (isLocalStorageAvailable) {
        setItem(playerUID, SYS_LANGUAGE, language);
    }
    document.documentElement.lang = language;
    return {type: CHANGE_SYSTEM_LANGUAGE, language};
}



// WEBPACK FOOTER //
// ./src/actions/settingsActions.js